export default function isMarried(maritalStatus: string) {
  return (
    maritalStatus === 'casado-brasileiro-nato' ||
    maritalStatus === 'casado-brasileiro-naturalizado' ||
    maritalStatus === 'casado-estrangeiro' ||
    maritalStatus === 'uniao-estavel'
  );
}
